import React, { cloneElement, isValidElement, Fragment } from 'react';

import parse, { HTMLReactParserOptions } from 'html-react-parser';

import articleStyle from '../app/knowledge-base/+post/+article-post/ArticlePost.module.scss';


enum NodeType {
  p = 'p',
  a = 'a',
}

const options: HTMLReactParserOptions = {
  library: {
    cloneElement,
    isValidElement,
    createElement: (type, props, children) => {
      if (!props) {
        return <></>;
      }

      switch (type) {
        case NodeType.a:
          // @ts-ignore
          return <a key={props.key} style={{ ...props.style }} href={props.href} target="_blank"
                    rel="noopener noreferrer" className={articleStyle.articlePost__link}>{children}</a>;
        case NodeType.p:
          if (children && children.type === 'div') {
            // @ts-ignore
            return <Fragment key={props.key}>{children}</Fragment>;
          }
          return <p
            // @ts-ignore
            key={props.key} style={{ ...props.style }}
            className={articleStyle.article__excerpt}
          >
            {children}
          </p>;
        default:
          // @ts-ignore
          return <Fragment key={props.key}>{children}</Fragment>;
      }
    },
  },
};

export const htmlToReactExcerpt = (html: string) => {
  return parse(html, options);
};
